import { IYoelloTheme } from '../../../themes/IYoelloTheme';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

function setItemFontStyles(
    fontStyle: string,
    fontWeight: any,
    fontSize: string,
    lineHeight: string,
    color: string,
): CSSProperties {
    return {
        fontStyle: fontStyle,
        fontWeight: fontWeight,
        fontSize: fontSize,
        lineHeight: lineHeight,
        color: color,
        margin: 0,
    };
}
export const useStyles = makeStyles((theme: IYoelloTheme) =>
    createStyles({
        aplliedFilters: {
            background: '#FFFCE6',
            border: '1px solid #FFDD02',
            boxSizing: 'border-box',
            borderRadius: '8px',
            '& >svg': {
                '& >path': {
                    fill: '#FFDD02!important',
                },
            },
        },
        filterBtn: {
            background: '#E8EAF4',
            borderRadius: '0.5rem',
            fontSize: '1rem',
            lineHeight: '1.375rem',
            padding: '0.75rem 1.5rem',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            '& >svg': {
                marginRight: ' 0.625rem',
                fill: '#C1CAE1',
                width: '0.875rem',
                height: '0.875rem',
                '& >path': {
                    fill: '#C1CAE1',
                },
            },
            '& >p': {
                ...setItemFontStyles('normal', 'normal', '1rem', '1.375rem', '#616161'),
                display: 'flex',
                alignItems: 'center',
                '& >span': {
                    marginLeft: '0.5rem',
                },
            },
        },
        sortButtonWrapper: {
            position: 'relative',
            '& >div': {
                '& strong': {
                    paddingLeft: '.2rem',
                },
            },
        },
        sortOptions: {
            position: 'absolute',
            background: '#FFFFFF',
            boxShadow: '0px 4px 20px rgba(33, 33, 33, 0.15)',
            borderRadius: '8px',
            marginTop: '0.3125rem',
            right: 0,
            padding: 0,
            listStyle: 'none',
            minWidth: '16rem',
            zIndex: 999,
            '& >li': {
                '& >p': {
                    ...setItemFontStyles('normal', 'normal', '0.875rem', '1.1875rem', '#616161'),
                    '&:hover': {
                        color: '#000000!important',
                    },
                },
                '&:hover': {
                    backgroundColor: '#F3F4F9',
                    borderRadius: '6px',
                },
                padding: '0.625rem 0.9375rem',
                margin: '0.3125rem',
                cursor: 'pointer',
            },
        },
        divider: {
            background: '#737FA4',
            opacity: '0.3',
            borderRadius: '10px',
            transform: 'matrix(-1, 0, 0, 1, 0, 0)',
            width: '1px',
            height: '2.5rem',
            margin: '0 1.5rem',
        },
        searchWrapper: {
            position: 'relative',
            "& .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root'] .MuiAutocomplete-input:first-child": {
                paddingLeft: '2.75rem!important',
                '&::placeholder': {
                    color: '#9E9E9E!important',
                },
            },
            '& >svg': {
                position: 'absolute',
                zIndex: 999,
                top: 12,
                left: 25,
                width: '1rem',
            },
        },
        searchRoot: {
            paddingBottom: '1rem',
        },
    }),
);
